module.exports = __webpack_public_path__ + "img/discover.c9f63a1a.png";